export default __webpack_public_path__ + "static/media/Vector.2482f06b.svg";